import { Venue, VenueEvent } from 'types/model'
import { EventListItem } from './event-list-item'
import { Button } from '@elements/button'

export interface EventListViewProps {
  venue?: Venue
  events?: VenueEvent[]
  loading?: boolean
  onItemClick: (event: VenueEvent) => void | Promise<void>
  loadMore?: () => void
  hasMore?: boolean
}

export function EventListView({
  venue,
  events,
  loading = false,
  onItemClick,
  loadMore,
  hasMore = false,
}: EventListViewProps) {
  return (
    <div className='space-y-3 sm:space-y-6'>
      {(!venue || !events) &&
        Array(20)
          .fill(0)
          .map((_, index) => <EventListItem.Skeleton key={index} />)}
      {venue &&
        events &&
        events.map((event, index) => (
          <EventListItem
            venue={venue}
            event={event}
            key={`${event.id}-${index}`}
            onClick={onItemClick}
          />
        ))}
      {events && hasMore && loadMore && (
        <Button.Floating
          loading={loading}
          onClick={loadMore}
          className='w-full'
        >
          Load More
        </Button.Floating>
      )}
    </div>
  )
}
